var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncOnline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "40px",
    viewBox: "0 0 46 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tablet-view/Navigation/Top-nav/New-assessment-2_online",
    transform: "translate(-1038.000000, -13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1038.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#99CC00",
    cx: 40,
    cy: 30,
    r: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons/Action/assignment_ind_black_24dp",
    transform: "translate(1.666667, 1.666667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 36.6666668 0 36.6666668 36.6666668 0 36.6666668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58333335,18.3333334 C4.58333335,21.7097223 5.97361114,24.7500001 8.18888893,26.9500001 L4.58333335,30.5555557 L13.7500001,30.5555557 L13.7500001,21.388889 L10.3277778,24.8111112 C8.67777782,23.1458334 7.63888892,20.8694445 7.63888892,18.3333334 C7.63888892,14.3458334 10.1902778,10.9541667 13.7500001,9.70138893 L13.7500001,6.50833336 C8.47916671,7.86805559 4.58333335,12.6347223 4.58333335,18.3333334 Z M16.8055556,25.9722223 L19.8611112,25.9722223 L19.8611112,22.9166668 L16.8055556,22.9166668 L16.8055556,25.9722223 Z M32.0833335,6.11111114 L22.9166668,6.11111114 L22.9166668,15.2777778 L26.338889,11.8555556 C27.988889,13.5208334 29.0277779,15.7972223 29.0277779,18.3333334 C29.0277779,22.3208334 26.476389,25.7125001 22.9166668,26.9652779 L22.9166668,30.1583335 C28.1875001,28.7986112 32.0833335,24.0319446 32.0833335,18.3333334 C32.0833335,14.9569445 30.6930557,11.9166667 28.4777779,9.71666671 L32.0833335,6.11111114 Z M16.8055556,19.8611112 L19.8611112,19.8611112 L19.8611112,10.6944445 L16.8055556,10.6944445 L16.8055556,19.8611112 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
export default SvgSyncOnline;